import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const Send = (props: SvgIconProps) => {
  return (
    <SvgIcon
      fontSize='inherit'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        d='M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default Send;
